import { ApiService } from 'src/app/services/api.service';

import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TripRoute, TripStop, TripZone } from '@shared/models';

@Component({
  selector: 'app-busstop-search',
  templateUrl: './busstop-search.component.html',
  styleUrls: ['./busstop-search.component.scss'],
})
export class BusstopSearchComponent implements OnInit {
  @Input() type = 'go';
  zones: TripZone[] = [];
  zone: TripZone | null = null;
  routes: TripRoute[] = [];
  route: TripRoute | null = null;
  stops: TripStop[] = [];
  stop: TripStop | null = null;
  loading: boolean = false;

  searchTerm = '';

  filteredStops: TripStop[] = []; // Store filtered data

  constructor(private modalController: ModalController, private apiService: ApiService) {}

  ngOnInit() {
    this.getZones();
    this.getRoutes();
  }

  getZones() {
    this.apiService
      .getData('zones')
      .then((res) => {
        console.log('zones: ', res);
        this.zones = res.data;
      })
      .finally(() => {});
  }

  getRoutes() {
    const zone = this.zone ? '&zone=' + this.zone.id : '';
    this.apiService
      .getData('routes?type=' + this.type + zone)
      .then((res) => {
        console.log('routes: ', res);
        this.routes = res.data;
      })
      .finally(() => {});
  }

  getStops() {
    if (!this.route) return;
    this.loading = true;
    this.apiService
      .getData('transportec-stops?route=' + this.route.id)
      .then((res) => {
        console.log('stops: ', res.data);
        this.stops = res.data;
        this.filteredStops = this.stops;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  getStopsAlt() {
    if (!this.route) return;
    this.apiService
      .getData('route/' + this.route.id)
      .then((res) => {
        console.log('stops: ', res);
        if (res && res.data) {
          this.stops = res.data[0].stops;
          this.filteredStops = this.stops;
        }
      })
      .finally(() => {});
  }

  selectZone(selected: TripZone) {
    if (selected) {
      console.log(selected);
      this.zone = selected;
      this.stops = [];
      this.routes = [];
      this.filteredStops = [];
      this.getRoutes();
    }
    console.log('zone: ', this.zone);
  }

  zoneCompare(a: { id: number }, b: { id: number }) {
    if (a && b && a.id === b.id) {
      return true;
    }
    return false;
  }

  selectRoute(selected: TripRoute) {
    if (selected) {
      this.route = selected;
      this.stops = [];
      this.filteredStops = [];
      this.getStops();
    }
    console.log(this.route);
  }

  routeCompare(a: TripRoute, b: TripRoute) {
    if (a && b && a.id === b.id) {
      return true;
    }
    return false;
  }

  setFilteredStops() {
    this.filteredStops = this.stops.filter((stop) => {
      return stop.name.toLowerCase().indexOf(this.searchTerm.toLowerCase()) > -1;
    });
  }

  closeModal() {
    this.modalController.dismiss();
  }

  select(selectedStop: TripStop) {
    this.modalController.dismiss({
      stop: selectedStop,
    });
  }
}
